import { render, staticRenderFns } from "./ProviderLoginButton.vue?vue&type=template&id=7c2d4a6f&scoped=true"
import script from "./ProviderLoginButton.vue?vue&type=script&lang=js"
export * from "./ProviderLoginButton.vue?vue&type=script&lang=js"
import style0 from "./ProviderLoginButton.vue?vue&type=style&index=0&id=7c2d4a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d4a6f",
  null
  
)

export default component.exports